
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"21.178","height":"21.178"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.123 1.032a1.333 1.333 0 010 2.12l-16.97 16.97a1.333 1.333 0 01-2.12 0 1.321 1.321 0 010-2.12q15.27-15.285 16.97-16.97a1.321 1.321 0 012.12 0z","fill":"#43B4EB"}}),_c('path',{attrs:{"d":"M1.033 1.032a1.321 1.321 0 012.12 0l16.97 16.97a1.321 1.321 0 010 2.12 1.333 1.333 0 01-2.12 0Q2.718 4.852 1.033 3.152a1.321 1.321 0 010-2.12z","fill":"#43B4EB"}})])
          )
        }
      }
    